import React from "react";
import { useSelector } from "react-redux";
import CIcon from "@coreui/icons-react";
import { store_getAuthUser } from "../../Auth/Auth.store";
import "./SubscriptionStatus.scss";

const SubscriptionStatus = () => {
    const user = useSelector(store_getAuthUser);

    const subscription = user?.subscriptions?.[0];

    if (!subscription) return null;

    const { thrivers, linkedThrivers, daysRemaining } = subscription;
    const percentage = thrivers > 0 ? (linkedThrivers / thrivers) * 100 : 0;

    return (
        <div className="subscription-status-bar home-status-bar">
            <div className="status-item">
                <div className="icon-wrapper">
                    <CIcon name="cil-shield-alt" size="custom" height={20} />
                </div>
                <div className="item-content">
                    <span className="item-label">Thriver Licences</span>
                    <div className="item-value">
                        <span>{linkedThrivers} / {thrivers}</span>
                        <div className="license-progress">
                            <div
                                className="progress-fill"
                                style={{ width: `${percentage}%` }}
                            ></div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="divider"></div>

            <div className="status-item">
                <div className="icon-wrapper" style={{ color: "#f6ad55" }}>
                    <CIcon name="cil-calendar" size="custom" height={20} />
                </div>
                <div className="item-content">
                    <span className="item-label">Renewal Status</span>
                    <div className="item-value">
                        <span className="renewal-text">{daysRemaining} Days Remaining</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SubscriptionStatus;